module.exports = __webpack_public_path__ + "static/media/dsv1.531c6fcb.jpeg";